import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import { capitalize } from "../../../../../lib/html5-software-library/src/ranj/util/StringUtil";

export default class InternalStakeholderButton extends Button {
    setNameLabel(label) {
        this._setLabelForTextField("name", label);
    }

    setPositionLabel(label) {
        this._setLabelForTextField("position", label);
    }

    _setLabelForTextField(textFieldPrefix, label, wordWrap = false) {
        for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
            const textField = this.skin[textFieldPrefix + capitalize(Button.TEXTFIELDNAMES[i])];
            if (textField) {
                textField.text = label;
                if (wordWrap) {
                    this._applyWordWrap(textField);
                }
            }
        }
    }

    _setState(state) {
        super._setState(state);

        this._setStateForTextField("name", state);
        this._setStateForTextField("position", state);
    }

    _setStateForTextField(textFieldPrefix, state) {
        for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
            const textField = this.skin[textFieldPrefix + capitalize(Button.TEXTFIELDNAMES[i])];
            if (textField) {
                textField.visible = false;
            }
        }

        const activeTextField = this.skin[textFieldPrefix + capitalize(state) + "LabelTextField"];
        if (activeTextField) {
            activeTextField.visible = true;
        }
    }
}